import { useCallback, useEffect, useRef, useState } from "react";

import {
  Card,
  CardContent,
  Divider,
  Grid,
  FormLabel,
  FormControl,
  Button,
  CardActions,
  TextField,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Typography,
  Modal,
  AppBar, IconButton, Box,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { useSnackbar } from "notistack";
import _, { replace } from "lodash";
import isUrl from "is-url";
import imageCompression from 'browser-image-compression';
// import { getCroppedImg, aspectRatios } from 'src/utils/imageUtils';
import CustomBreadcrumbs from "components/Breadcrumbs";
import Cropper from 'react-easy-crop';
import Slider from '@mui/material/Slider';

import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import Loader from "components/Loader";
import PreviewModal from "components/Template/PreviewModal";
import ImageUploader, { ImageUploader1 } from "components/Inputs/ImageUploader";
import CloseIcon from '@mui/icons-material/Close';
import Swal from 'sweetalert2';

const Template = ({ breadcrumbs }) => {
  const [logo, setLogo] = useState([]);
  const [banner, setBanner] = useState([]);
  const [isSetUrl, setIsSetUrl] = useState(false);
  const [bannnerSize, setBannnerSize] = useState({});
  const [brand, setBrand] = useState([]);
  const [aboutImg, setaboutImg] = useState([]);
  const [loader, setLoader] = useState(false);
  const [getimage, setGetimage] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [color1, setColor1] = useState("#ffffff");
  const [color2, setColor2] = useState("#000000");
  const [color3, setColor3] = useState("#ffffff");
  const [color4, setColor4] = useState("#000000");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  const handlePreviewModal = () => {
    setIsPreviewModalOpen(!isPreviewModalOpen);
  };
  const handleColor1Change = (event) => {
    setColor1(event.target.value);
  };

  const handleColor2Change = (event) => {
    setColor2(event.target.value);
  };
  const handleColor3Change = (event) => {
    setColor3(event.target.value);
  };

  const handleColor4Change = (event) => {
    setColor4(event.target.value);
  };
  console.log("brand1", brand)

  const getWebDetails = async () => {
    setBannnerSize({})
    setLoader(true);
    let res = await axiosInstance.get(
      APIRouteConstants.WEBSITE.WEB_LOGO_BANNER
    );
    if (res === false) {
      setLoader(false);
      return;
    }
    let { data, response } = res;

    if (data) {
      setGetimage(true)

      if (data["logo"]) setLogo([data["logo"]]);
      if (data["about_main_image"]) setaboutImg([data["about_main_image"]]);
      if (data["about_us_images"]) {
        const modifiedBrand = data["about_us_images"]?.map((item) => item)
        setBrand([modifiedBrand])
      };
      if (data["banner"]) setBanner([data["banner"]]);
      if (data["header_bg"]) setColor1([data["header_bg"]]);
      if (data["header_text"]) setColor2([data["header_text"]]);
      if (data["footer_bg"]) setColor3([data["footer_bg"]]);
      if (data["footer_text"]) setColor4([data["footer_text"]]);
    }
    setLoader(false);
  };
  const [openCropperDia, setOpenCropperDia] = useState(true);
  console.log("brand", brand)
  const updateWebDetail = async () => {
    // if (_.isEmpty(logo)) {
    //     enqueueSnackbar('Logo is mandatory', { variant: 'error' });
    //     return;
    // }
    setOpenCropperDia(false)
    setLoader(true);
    let formData = new FormData();
    if (logo[0] && !isUrl(logo[0])) {
      formData.append("logo", logo[0], logo[0]?.fileName);
    } else if (logo[0]) {
      formData.append("logo", logo[0]);
    }
    // else{ formData.append('logo',"")}
    if (banner[0] && !isUrl(banner[0]))
      formData.append("banner", banner[0], banner[0]?.fileName);
    if (aboutImg[0] && !isUrl(aboutImg[0]) && aboutImg[0] instanceof File) {
      formData.append("about_main_image", aboutImg[0], aboutImg[0].fileName);
    }
    const modifiedBrand = brand && brand.filter((item) => item instanceof File); // files
    const existingBrand = brand && brand.filter((item, i) => typeof item[i] === 'string'); // URLs

    // Append File instances
    if (modifiedBrand && Array.isArray(modifiedBrand)) {
      modifiedBrand.forEach((file, i) => {
        formData.append(`about_us_images[${i}]`, file);
      });
    }

    // Append URL strings
    if (existingBrand && Array.isArray(existingBrand)) {
      const UsedBrand = Array.isArray(existingBrand[0]) ? existingBrand[0] : existingBrand;
      // console.log("modified", UsedBrand)
      // return
      UsedBrand && UsedBrand.forEach((url, i) => {
        console.log("modified", `about_us_images[${modifiedBrand.length + i}]`, url)
        formData.append(`about_us_images[${modifiedBrand.length + i}]`, url);
      });
    }
    // if (brand[0] && !isUrl(brand[0]))
    //   formData.append("banner", banner[0], banner[0]?.fileName);
    if (color1 != "") {
      formData.append("header_bg", color1);
    }
    if (color2 != "") {
      formData.append("header_text", color2);
    }
    if (color3 != "") {
      formData.append("footer_bg", color3);
    }
    if (color4 != "") {
      formData.append("footer_text", color4);
    }
    const res = await axiosInstance({
      method: "post",
      url: APIRouteConstants.WEBSITE.WEB_LOGO_BANNER,
      data: formData,
    });
    if (res === false) {
      setLoader(false);
      return;
    }
    let { data, response } = res;
    if (response && response.status === 400 && response.data) {
      for (let i in response.data) {
        enqueueSnackbar(_.capitalize(i) + ": " + response.data[i], {
          variant: "error",
        });
      }
    }
    if (!_.isEmpty(data)) {
      enqueueSnackbar("Details updated  successfully", { variant: "success" });
      window.location.reload();
    }
    setLoader(false);
  };

  useEffect(() => {
    getWebDetails();
  }, []);

  const imageUploaderRef = useRef();
  const triggerImageUpload = () => {
    if (imageUploaderRef.current) {
      imageUploaderRef.current(); // This triggers the file input in ImageUploader
    }
  };
  const imageUploaderRef2 = useRef();
  const triggerImageUpload2 = () => {
    if (imageUploaderRef2.current) {
      imageUploaderRef2.current(); // This triggers the file input in ImageUploader
    }
  };
  const imageUploaderRef3 = useRef();
  const triggerImageUpload3 = () => {
    if (imageUploaderRef3.current) {
      imageUploaderRef3.current(); // This triggers the file input in ImageUploader
    }
  };
  const imageUploaderRef4 = useRef();
  const triggerImageUpload4 = () => {
    if (imageUploaderRef4.current) {
      imageUploaderRef4.current(); // This triggers the file input in ImageUploader
    }
  };

  console.log("sizes", bannnerSize)

  // function ImageChecker({ bannerSize }) {
  //   useEffect(() => {
  //     // setBanner({})
  //     if (bannerSize.width < 1255 || bannerSize.height < 600) {
  //       Swal.fire({
  //         title: "Banner Size Too Small",
  //         text: "To make your banner look great, please upload an image that's 1255px wide and 600px tall. Other sizes might not display correctly.",
  //         icon: "warning",
  //         // timer: 5000,
  //         showConfirmButton: true,
  //         timerProgressBar: false,
  //         customClass: {
  //           popup: 'small-swal-popup',
  //           title: 'small-swal-title',
  //           htmlContainer: 'small-swal-text',
  //           confirmButton: 'small-swal-button',
  //         },
  //       }).then((result) => {
  //         if (result.dismiss === Swal.DismissReason.timer) {
  //           console.log("Alert closed automatically after 5 seconds");
  //         }
  //       });

  //     }
  //   }, [bannerSize]);

  //   return null;
  // }

  function ImageChecker({ bannerSize, banner, onSave,openCropperDia, setOpenCropperDia }) {
    const [openCropper, setOpenCropper] = useState(false);

    // useEffect(() => {
    //   // if (bannerSize.width < 1255 || bannerSize.height < 600) {
    //     Swal.fire({
    //       title: "Banner Size Too Small",
    //       text: "Please upload an image that's 1255px wide and 600px tall.",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonText: "Crop Image",
    //       cancelButtonText: "Cancel",
    //       customClass: {
    //         popup: 'small-swal-popup',
    //         title: 'small-swal-title',
    //         htmlContainer: 'small-swal-text',
    //         confirmButton: 'small-swal-button',
    //         cancelButton: 'small-swal-button',
    //       },
    //     }).then((result) => {
    //       if (result.isConfirmed) {
    //         setOpenCropper(true); // Open Cropper Dialog
    //       }
    //     });
    //   // }
    // }, [bannerSize]);

    // useEffect(() => {
    //   Swal.fire({
    //     title: "Banner Size Too Small",
    //     text: "Please upload an image that's 1255px wide and 600px tall.",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "Crop Image",
    //     cancelButtonText: "Cancel",
    //     customClass: {
    //       popup: 'small-swal-popup',
    //       title: 'small-swal-title',
    //       htmlContainer: 'small-swal-text',
    //       confirmButton: 'small-swal-button',
    //       cancelButton: 'small-swal-button',
    //     },
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       setOpenCropper(true);
    //     }
    //   });
    // }, []); // 🔹 empty dependency => run once when component mounts

    useEffect(() => {
      if (
        //   // bannerSize &&
        //   // bannerSize.width > 0 &&
        //   // bannerSize.height > 0 &&
        (bannerSize.width > 0 || bannerSize.height > 0) && openCropperDia
      ) {
        Swal.fire({
          title: "Optimize Your Banner",
          text: "To provide a better user experience, please crop your image before uploading",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Crop Image",
          cancelButtonText: "Continue with selected image",
          customClass: {
            popup: 'small-swal-popup',
            title: 'small-swal-title',
            htmlContainer: 'small-swal-text',
            confirmButton: 'green-confirm-button',
            cancelButton: 'small-swal-button',
          },
        }).then((result) => {
          if (result.isConfirmed) {
            setOpenCropper(true);
          }
        });
      }
    }, []);

    return (
      <>
        {openCropper && (
          <ImageCropperUploaderDialog open={openCropper} onSave={onSave} imageList={banner} onClose={() => setOpenCropper(false)} openCropperDia={openCropperDia} setOpenCropperDia={setOpenCropperDia} />        )}
      </>
    );
    // return (
    //   <>
    //     {openCropper && (
    //       <ImageCropperUploaderDialog open={openCropper} onClose={() => setOpenCropper(false)} />
    //     )}
    //   </>
    // );
    // return (
    //   <>
    //     {openCropper && <ImageCropperUploaderDialog open={openCropper} onClose={() => setOpenCropper(false)} />}
    //   </>
    // );
  }


  const [openCropper, setOpenCropper] = useState(false);

  const handleRecommendedSizeClick = () => {
    setOpenCropper(true);
  };

  const parseResolution = (resolutionStr) => {
    const [width, height] = resolutionStr.split('x');
    return {
      width: `${width}px`,
      height: `${height}px`,
    };
  };
  
  const handleBannerSave = (file,size) => {
    // Store in form state, or upload to server, etc.
    setBanner(file)
    setIsSetUrl(true)
    setBannnerSize(parseResolution(size))
  }; 
  
  console.log('Selected banner file:', openCropperDia);
  


  return (
    <div className="store-analytics-wrapper">
      <Loader open={loader} />
      <div className="breadcrumb-wrapper">
        <CustomBreadcrumbs list={breadcrumbs} name={"Website Template"} />
      </div>
      {/* {(bannnerSize.width < 1255 || bannnerSize.height < 600) &&  */}
      <ImageChecker bannerSize={bannnerSize} banner={banner} onSave={handleBannerSave} openCropperDia={openCropperDia} setOpenCropperDia={setOpenCropperDia} />      {/* } */}
      {/* {(bannnerSize.width < 1255 || bannnerSize.height < 600) && enqueueSnackbar("To make your banner look great, please upload an image that's 1255px wide and 600px tall. Other sizes might not display correctly.", { variant: "error" })} */}
      <Grid container className="component-grid">
        <Grid item xs={12}>
          <Card className="dashboard-card-wrapper">
            <CardContent>
              <div className="header-wrapper">
                <span className="header-text">
                  {/* Build and manage your website */}
                  Set up your About Us page
                </span>
              </div>
              <Divider />
              <div className="content-wrapper">
                <span className="content-text">
                  {/* Using our Quick store method, you will be able to easily build
                  your website within minutes that works perfectly on desktop
                  and mobile. We will soon be releasing the ability to build
                  your own template using a drag and drop editor as well as
                  building your website using multiple pre-designed templates. */}
                  Using our Quick store method, you will be able to easily build your website within minutes that works perfectly on desktop and mobile.
                </span>
                <br />
                <br />
                <span className="content-text">
                  {/* Add your logo to your website and customise the colours on
                  your store template here. */}
                  <b>Coming Soon:</b>  We will be releasing the ability to build your own template using a drag and drop editor as well as building your website using multiple pre-designed templates.
                </span>
              </div>
              <Grid
                container
                className="dashboard-form-container"
                spacing={4}
                wrap="wrap"
              >
                <Grid item md={6} sm={12} xs={12} >
                  <div className="form-wrapper">
                    <FormLabel
                      className="form-label"
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        <span className="label-text">
                          Upload Your Logo (Optional)
                        </span>
                        <Button
                          onClick={triggerImageUpload}
                          size="small"
                          sx={{ p: 0, pl: 1, pr: 1, textTransform: "none" }}
                          variant="contained"
                          color="secondary"
                        >
                          Upload
                        </Button>
                      </div>
                      <span className="label-sec-text" style={{
                        color: "grey",
                        // marginBottom: "44px"
                      }}>
                        This logo will be displayed at the top right-hand corner of your online store.
                        <br />
                        {/* <span className="label-sec-text" style={{color: "grey"}}>
                      Recommended size: (1024 x 1024 pixels)
                      </span> */}
                      </span>
                      <br />
                      <br />
                    </FormLabel>

                    <FormControl className="form-control">
                      <ImageUploader1
                        message={"Recommended size: 1024 x 1024 pixels"}
                        imageList={logo}
                        setImageList={setLogo}
                        replaceImage={(callback) =>
                          (imageUploaderRef.current = callback)
                        }
                        id="logo"
                        name="logo"
                      />
                    </FormControl>
                    <FormLabel
                      className="form-label"
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <span className="label-sec-text" style={{ color: "grey" }}>
                        Recommended size: (1024 x 1024 pixels)
                      </span>
                    </FormLabel>
                  </div>
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                  <div className="form-wrapper">
                    {/* <FormLabel className="form-label" >
                      <span className="label-text">
                        Upload a custom banner (optional)
                      </span>
                      <Button
                          onClick={triggerImageUpload}
                          size="small"
                          sx={{ p: 0, pl: 1, pr: 1, textTransform: "none" }}
                          variant="contained"
                          color="secondary"
                        >
                          Upload
                        </Button>
                      <br />
                      <span className="label-sec-text">
                        Design and upload a banner for your Shop page.
                      </span>
                    </FormLabel> */}
                    <FormLabel
                      className="form-label"
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        <span className="label-text">
                          Upload a Custom Banner (Optional)
                        </span>
                        <Button
                          onClick={triggerImageUpload2}
                          size="small"
                          sx={{ p: 0, pl: 1, pr: 1, textTransform: "none" }}
                          variant="contained"
                          color="secondary"
                        >
                          Upload
                        </Button>
                      </div>
                      {/* <span className="label-sec-text" style={{color: "grey"}}>
                      This banner image will be displayed on your Home, About Us, and Contact Us pages.
                      <br/>
                      <span className="label-sec-text" style={{color: "grey"}}>
                      Recommended size: 3840 x 2160 pixels
                      </span>
                      <br/>
                      <span>
                      <b>Note:</b> If you don't have a banner ready, we've added a dummy banner for now. You can replace it later when you're ready!
                      </span>
                      </span> */}
                      <span className="label-sec-text" style={{ color: "grey", paddingBottom: "7px" }}>
                        This banner image will be displayed on your Home, About Us, and Contact Us pages.
                        <br />
                        {/* <span className="label-sec-text" style={{color: "grey"}}>
                          Recommended size: (3840 x 2160 pixels)
                        </span>
                        <br/> */}
                        <span>
                          <b>Note:</b> If you don't have a banner ready, we've added a dummy banner for now. You can replace it later when you're ready!
                        </span>
                      </span>
                    </FormLabel>
                    {/* <Box sx={{ display: 'flex', 
                      // justifyContent: 'flex-end',
                      alignItems: 'center', mb: 1 }}>
        <Button variant="outlined" size="small" onClick={handleRecommendedSizeClick}>
          Crop Image
        </Button>
      </Box> */}
                    <div>

                      {openCropper && (
                        <ImageCropperUploaderDialog
                          open={openCropper}
                          onClose={() => setOpenCropper(false)}
                          openCropperDia={openCropperDia}
                        />
                      )}
                    </div>
                    <FormControl className="form-control">
                      {/* <ImageUploader
                        id="banner"
                        name="banner"
                        imageList={banner}
                        setImageList={setBanner}
                      /> */}
                      <ImageUploader1
                        message={"Recommended size: 1280 x 720 pixels"}
                        id="banner"
                        name="banner"
                        label="custombanner"
                        imageList={banner}
                        isSetUrl={isSetUrl}
                        setImageList={setBanner}
                        setBannnerSize={setBannnerSize}
                        replaceImage={(callback) =>
                          (imageUploaderRef2.current = callback)
                        }
                      />
                    </FormControl>
                    <FormLabel
                      className="form-label"
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <span className="label-sec-text" style={{ color: "grey" }}>
                        Recommended size: (1280 x 720 pixels)
                      </span>
                    </FormLabel>
                    <div>
                      {/* <FormLabel
        className="form-label"
        sx={{ display: "flex", flexDirection: "column", gap: 1, cursor: 'pointer' }} // Added cursor style
        onClick={handleRecommendedSizeClick} // Added onClick handler
      >
        <span className="label-sec-text" style={{ color: "grey" }}>
          Recommended size: (1024 x 1024 pixels)
        </span>
      </FormLabel> */}

                      {openCropper && (
                        <ImageCropperUploaderDialog
                          open={openCropper}
                          onClose={() => setOpenCropper(false)}
                          openCropperDia={openCropperDia}
                        />
                      )}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
  <div className="form-wrapper" style={{ padding: '16px' }}>
    <Grid container spacing={2} alignItems="stretch">
      {/* Left Column */}
      <Grid item md={6} sm={12} xs={12}>
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <FormLabel
            className="form-label"
            sx={{ display: "flex", flexDirection: "column", gap: 1 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              <span className="label-text" style={{ paddingTop: "4px" }}>
                About Us Page Image (Optional)
              </span>
              <Button
                style={{ marginTop: "4px" }}
                onClick={triggerImageUpload3}
                size="small"
                sx={{ p: 0, pl: 1, pr: 1, textTransform: "none" }}
                variant="contained"
                color="secondary"
              >
                Upload
              </Button>
            </div>
            <span className="label-sec-text" style={{ color: "grey", marginBottom: "16px" }}>
              This image will be displayed beside your About Us content.
            </span>
          </FormLabel>

          <FormControl className="form-control" style={{ paddingTop: "31px" }} sx={{ flexGrow: 1 }}>
            <ImageUploader1
              message={"Recommended size: 1024 x 1024 pixels"}
              imageList={aboutImg}
              setImageList={setaboutImg}
              replaceImage={(callback) => (imageUploaderRef3.current = callback)}
              id="aboutus_logo"
              name="aboutus_logo"
            />
          </FormControl>

          <FormLabel
            className="form-label"
            sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}
          >
            <span className="label-sec-text" style={{ color: "grey" }}>
              Recommended size: (1024 x 1024 pixels)
            </span>
          </FormLabel>
        </div>
      </Grid>

      {/* Right Column */}
      <Grid item md={6} sm={12} xs={12}>
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <FormLabel
            className="form-label"
            sx={{ display: "flex", flexDirection: "column", gap: 1 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              <span className="label-text">Image(s) for About Us Page (Optional)</span>
              <Button
                onClick={triggerImageUpload4}
                size="small"
                sx={{ p: 0, pl: 1, pr: 1, textTransform: "none" }}
                variant="contained"
                color="secondary"
              >
                Upload
              </Button>
            </div>
            <span className="label-sec-text" style={{ color: "grey", marginBottom: "16px" }}>
              These image(s) will appear below your About Us content. Upload up to 5 images.
              You can upload images related to your product, store, team members, etc.
            </span>
          </FormLabel>

          <FormControl className="form-control" style = {{paddingTop: "25px"}} sx={{ flexGrow: 1 }}>
            <ImageUploader
              multiple={true}
              getimage={getimage}
              message={"Recommended size: 1024 x 1024 pixels"}
              imageList={brand}
              setImageList={setBrand}
              replaceImage={(callback) => (imageUploaderRef4.current = callback)}
              id="brand_logo"
              name="brand_logo"
            />
          </FormControl>

          <FormLabel
            className="form-label"
            sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}
          >
            <span className="label-sec-text" style={{ color: "grey" }}>
              Recommended size: (1024 x 1024 pixels)
            </span>
          </FormLabel>
        </div>
      </Grid>
    </Grid>
  </div>
</Grid>

              </Grid>
              <Grid
                container
                className="dashboard-form-container"
                spacing={4}
                wrap="wrap"
              >
                <Grid item md={6} sm={12} xs={12}>
                  <div className="form-wrapper">
                    <FormLabel className="form-label">
                      <span className="label-text">
                        Select Your Header Background and Text Color
                      </span>
                      <br />
                      <span className="label-sec-text" style={{ color: "grey" }}>
                        These will be the background and text colors displayed for your online store’s header.
                      </span>
                    </FormLabel>
                    <FormControl
                      className="form-control"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ marginBottom: "16px", width: "30%" }}>
                        {/* <Typography pb={2} style={{ fontSize: "14px" }}>
                          Selected Color: {color1}
                        </Typography> */}
                        <TextField
                          fullWidth
                          label="Background"
                          type="color"
                          value={color1}
                          onChange={handleColor1Change}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                      <div style={{ width: "30%" }}>
                        {/* <Typography pb={2} style={{ fontSize: "14px" }}>
                          Selected Color: {color2}
                        </Typography> */}
                        <TextField
                          fullWidth
                          label="Text"
                          type="color"
                          value={color2}
                          onChange={handleColor2Change}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    </FormControl>
                  </div>
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                  <div className="form-wrapper">
                    <FormLabel className="form-label">
                      <span className="label-text">
                        Select Your Footer Background and Text Color
                      </span>
                      <br />
                      <span className="label-sec-text" style={{ color: "grey" }}>
                        These will be the background and text colors displayed for your online store’s footer.
                      </span>
                    </FormLabel>
                    <FormControl className="form-control">
                      <FormControl
                        className="form-control"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ marginBottom: "16px", width: "30%" }}>
                          {/* <Typography pb={2} style={{ fontSize: "14px" }}>
                            Selected Color: {color3}
                          </Typography> */}
                          <TextField
                            fullWidth
                            label="Background"
                            type="color"
                            value={color3}
                            onChange={handleColor3Change}
                            InputLabelProps={{ shrink: true }}
                          />
                        </div>
                        <div style={{ width: "30%" }}>
                          {/* <Typography pb={2} style={{ fontSize: "14px" }}>
                            Selected Color: {color4}
                          </Typography> */}
                          <TextField
                            fullWidth
                            label="Text"
                            type="color"
                            value={color4}
                            onChange={handleColor4Change}
                            InputLabelProps={{ shrink: true }}
                          />
                        </div>
                      </FormControl>
                    </FormControl>
                  </div>
                </Grid>
              </Grid>
              <Divider />
            </CardContent>
            <CardActions className="footer-wrapper">
              <div className="action-wrapper">
                <Button
                  variant="contained"
                  onClick={handlePreviewModal}
                  color="secondary"
                >
                  Preview
                </Button>
              </div>
              <div className="action-wrapper">
                <Button
                  variant="contained"
                  onClick={updateWebDetail}
                  color="secondary"
                >
                  Update
                </Button>
              </div>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
      {/* <ImageCropperUploader/> */}
      <PreviewModal
        headerbg={color1}
        headertext={color2}
        footerbg={color3}
        footertext={color4}
        isPreviewModalOpen={isPreviewModalOpen}
        handleClose={handlePreviewModal}
      />
    </div>
  );
};

export default Template;


// const aspectRatios = {
//   '16:9': 16 / 9,
//   '21:9': 21 / 9,
// };

// const ImageCropperUploader = () => {
//   const [imageSrc, setImageSrc] = useState(null);
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   const [zoom, setZoom] = useState(1);
//   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
//   const [aspect, setAspect] = useState('16:9');
//   const [croppedImages, setCroppedImages] = useState({});

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = () => setImageSrc(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const onCropComplete = useCallback((_, croppedPixels) => {
//     setCroppedAreaPixels(croppedPixels);
//   }, []);

//   const showCroppedBanners = async () => {
//     const widths = [1280, 1920, 3840, 5000];
//     const banners = {};

//     for (const width of widths) {
//       const result = await getCroppedImg(imageSrc, croppedAreaPixels, width, width / aspectRatios[aspect]);
//       banners[width] = result;
//     }

//     setCroppedImages(banners);
//   };

//   const download = (blob, name) => {
//     const a = document.createElement('a');
//     a.href = URL.createObjectURL(blob);
//     a.download = name;
//     a.click();
//   };

//   return (
//     <div style={{ maxWidth: 800, margin: '0 auto' }}>
//       <h2>Upload & Crop Banner Image</h2>
//       <input type="file" accept="image/*" onChange={handleImageUpload} />

//       {imageSrc && (
//         <>
//           <div style={{ position: 'relative', height: 400, marginTop: 20 }}>
//             <Cropper
//               image={imageSrc}
//               crop={crop}
//               zoom={zoom}
//               aspect={aspectRatios[aspect]}
//               onCropChange={setCrop}
//               onZoomChange={setZoom}
//               onCropComplete={onCropComplete}
//             />
//           </div>

//           <div style={{ marginTop: 10 }}>
//             <label>Aspect Ratio: </label>
//             <select value={aspect} onChange={(e) => setAspect(e.target.value)}>
//               <option value="16:9">16:9</option>
//               <option value="21:9">21:9</option>
//             </select>
//           </div>

//           <div style={{ width: 200, margin: '20px 0' }}>
//             <Slider
//               value={zoom}
//               min={1}
//               max={3}
//               step={0.1}
//               onChange={(e, zoom) => setZoom(zoom)}
//             />
//           </div>

//           <Button variant="contained" onClick={showCroppedBanners}>
//             Generate Banner Sizes
//           </Button>
//         </>
//       )}

//       <div style={{ marginTop: 30 }}>
//         {Object.entries(croppedImages).map(([size, { blob, url }]) => (
//           <div key={size} style={{ marginBottom: 20 }}>
//             <h4>{size}px banner</h4>
//             <img src={url} style={{ maxWidth: '100%' }} alt={`Banner ${size}`} />
//             <br />
//             <Button onClick={() => download(blob, `banner-${size}.jpg`)}>
//               Download {size}px
//             </Button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// function getCroppedImg(imageSrc, cropPixels, targetWidth, targetHeight) {
//   return new Promise((resolve) => {
//     const image = new Image();
//     image.src = imageSrc;
//     image.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = targetWidth;
//       canvas.height = targetHeight;
//       const ctx = canvas.getContext('2d');

//       ctx.drawImage(
//         image,
//         cropPixels.x,
//         cropPixels.y,
//         cropPixels.width,
//         cropPixels.height,
//         0,
//         0,
//         targetWidth,
//         targetHeight
//       );

//       canvas.toBlob((blob) => {
//         resolve({ blob, url: URL.createObjectURL(blob) });
//       }, 'image/jpeg', 0.9);
//     };
//   });
// }


const aspectRatios = {
  '16:9': 16 / 9,
  '21:9': 21 / 9,
};

function getCroppedImg(imageSrc, cropPixels, targetWidth, targetHeight) {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        cropPixels.x,
        cropPixels.y,
        cropPixels.width,
        cropPixels.height,
        0,
        0,
        targetWidth,
        targetHeight
      );

      canvas.toBlob((blob) => {
        resolve({ blob, url: URL.createObjectURL(blob) });
      }, 'image/jpeg', 0.9);
    };
  });
}


// const ImageCropperUploaderDialog = ({ open, onClose }) => {
//   const [imageSrc, setImageSrc] = useState(null);
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   const [zoom, setZoom] = useState(1);
//   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
//   const [aspect, setAspect] = useState('16:9');
//   const [croppedImages, setCroppedImages] = useState({});

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = () => setImageSrc(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const onCropComplete = useCallback((_, croppedPixels) => {
//     setCroppedAreaPixels(croppedPixels);
//   }, []);

//   const showCroppedBanners = async () => {
//     const widths = [1280, 1920, 3840, 5000];
//     const banners = {};

//     for (const width of widths) {
//       const result = await getCroppedImg(imageSrc, croppedAreaPixels, width, width / aspectRatios[aspect]);
//       banners[width] = result;
//     }

//     setCroppedImages(banners);
//   };

//   const download = (blob, name) => {
//     const a = document.createElement('a');
//     a.href = URL.createObjectURL(blob);
//     a.download = name;
//     a.click();
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//       <DialogTitle>
//         Upload & Crop Banner Image
//         <IconButton
//           aria-label="close"
//           onClick={onClose}
//           sx={{
//             position: 'absolute',
//             right: 8,
//             top: 8,
//             color: (theme) => theme.palette.grey[500],
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>
//       <DialogContent>
//         <div style={{ maxWidth: '100%' }}>
//           <input type="file" accept="image/*" onChange={handleImageUpload} />

//           {imageSrc && (
//             <>
//               <div style={{ position: 'relative', height: 400, marginTop: 20 }}>
//                 <Cropper
//                   image={imageSrc}
//                   crop={crop}
//                   zoom={zoom}
//                   aspect={aspectRatios[aspect]}
//                   onCropChange={setCrop}
//                   onZoomChange={setZoom}
//                   onCropComplete={onCropComplete}
//                 />
//               </div>

//               <div style={{ marginTop: 10 }}>
//                 <label>Aspect Ratio: </label>
//                 <select value={aspect} onChange={(e) => setAspect(e.target.value)}>
//                   <option value="16:9">16:9</option>
//                   <option value="21:9">21:9</option>
//                 </select>
//               </div>

//               <div style={{ width: 200, margin: '20px 0' }}>
//                 <Slider
//                   value={zoom}
//                   min={1}
//                   max={3}
//                   step={0.1}
//                   onChange={(e, zoom) => setZoom(zoom)}
//                 />
//               </div>

//               <Button variant="contained" onClick={showCroppedBanners}>
//                 Generate Banner Sizes
//               </Button>
//             </>
//           )}

//           <div style={{ marginTop: 30 }}>
//             {Object.entries(croppedImages).map(([size, { blob, url }]) => (
//               <div key={size} style={{ marginBottom: 20 }}>
//                 <h4>{size}px banner</h4>
//                 <img src={url} style={{ maxWidth: '100%' }} alt={`Banner ${size}`} />
//                 <br />
//                 <Button onClick={() => download(blob, `banner-${size}.jpg`)}>
//                   Download {size}px
//                 </Button>
//               </div>
//             ))}
//           </div>
//         </div>
//       </DialogContent>
//     </Dialog>
//   );
// };


const ImageCropperUploaderDialog = ({ open, onClose, imageList, onSave, setOpenCropperDia }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [aspect, setAspect] = useState('16:9');
  const [croppedImages, setCroppedImages] = useState({});

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setImageSrc(reader.result);
    reader.readAsDataURL(file);
  };

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  useEffect(() => {
    if (!imageList || imageList.length === 0) return;

    const file = imageList[0]; // Use the first file from the array
    const reader = new FileReader();

    reader.onload = () => setImageSrc(reader.result);
    reader.readAsDataURL(file);
  }, [imageList]);


  const showCroppedBanners = async () => {
    const sizes = [
      { width: 1280, height: 720 },
      { width: 1920, height: 1080 },
    ];

    const banners = {};

    for (const size of sizes) {
      const result = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        size.width,
        size.height
      );

      banners[`${size.width}x${size.height}`] = result; // Keep blob & url
    }

    setCroppedImages(banners);
  };


console.log("Selected banner file:",imageList)
  const handleCloseAndRefresh = () => {
    if (onClose) {
      onClose(); // Call the original onClose function if provided
    }
    window.location.reload(); // Trigger a page refresh
  };

  const onMediaLoaded = (mediaSize) => {
    const { naturalWidth, naturalHeight } = mediaSize;

    // Example: move crop focus to top-center for portrait images
    if (naturalHeight > naturalWidth) {
      setCrop({ x: 0, y: -30 }); // Move up
    } else {
      setCrop({ x: 0, y: 0 }); // Default center
    }
  };



  return (
    <Dialog open={open} onClose={handleCloseAndRefresh} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        Upload & Crop Banner Image
        <IconButton
          aria-label="close"
          onClick={handleCloseAndRefresh} // Use the new handler
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ justifyContent: 'center' }}>
        <div style={{ maxWidth: '100%' }}>
          <input
            type="file"
            accept="image/*"
            id="fileUpload"
            onChange={handleImageUpload}
            style={{ display: 'none' }}
          />

          <Button variant="outlined" sx={{ bgcolor: "#000", color: "white" }} onClick={() => document.getElementById('fileUpload').click()}>
            Choose banner
          </Button>
          <Typography ml={2} variant="outlined">
            {imageList?.[0]?.name || 'Choose File'}
          </Typography>


          {imageSrc && (
            <>
              <div style={{ position: 'relative', height: 400, marginTop: 20, width: "100%" }}>
                <Cropper
                  style={{ width: "100%" }}
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  minZoom={1}
                  maxZoom={3}
                  aspect={aspectRatios[aspect]}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onMediaLoaded={({ naturalWidth, naturalHeight }) =>
                    onMediaLoaded({ naturalWidth, naturalHeight })
                  }
                  onCropComplete={onCropComplete}
                />
              </div>

              <Box sx={{ mt: 3 }}>
  <FormControl fullWidth size="small">
    <InputLabel id="aspect-ratio-label">Aspect Ratio</InputLabel>
    <Select
      labelId="aspect-ratio-label"
      value={aspect}
      label="Aspect Ratio"
      onChange={(e) => setAspect(e.target.value)}
    >
      <MenuItem value="16:9">16:9</MenuItem>
      <MenuItem value="21:9">21:9</MenuItem>
    </Select>
  </FormControl>
</Box>

              <div style={{ width: '100%', margin: '20px 0', display: 'flex'}}>
                <label style={{marginRight: '10px'}}>Zoom In</label>
                <Slider
                style={{ width: '70%', marginLeft: 10 }}
                  value={zoom}
                  min={1}
                  max={3}
                  step={0.1}
                  onChange={(e, zoom) => setZoom(zoom)}
                />
                <label style={{marginLeft: '10px'}}>Zoom Out</label>
              </div>

              <Button variant="contained" onClick={showCroppedBanners}>
                Generate Banner Sizes
              </Button>
            </>
          )}

          <div style={{ marginTop: 30 }}>
            {Object.entries(croppedImages).map(([size, { blob, url }]) => (
              <div key={size} style={{ marginBottom: 20 }}>
                <h4>{size}px banner</h4>
                <img src={url} style={{ maxWidth: '100%' }} alt={`Banner ${size}`} />
                <br />
                <Button
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={() => {
                    const file = new File([blob], `banner-${size}.jpg`, { type: 'image/jpeg' });
                    if (onSave) onSave([file],size);
                    if (onClose) onClose(); // optionally close dialog
                    setOpenCropperDia(false)
                  }}
                >
                  Use This Size
                </Button>
              </div>
            ))}
          </div>

        </div>
      </DialogContent>
    </Dialog>
  );
};
